// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateLaborAdditiveSummary = laborAdditiveSummary => ({
    laborAdditiveSummary,
    type: actions.UPDATE_HOME_PAGE_LABOR_ADDITIVE_SUMMARY
});



// WEBPACK FOOTER //
// ./src/home-page/action-creators/labor-additive-summary.js